import { Box, Grid, Paper, Typography } from "@mui/material";
import { DiscoverViewContext } from "contexts/DiscoverView";
import { useContext } from "react";

import Markdown from "components/Markdown";

import ActionItem from "./ActionItem";
import BrandCard from "./BrandCard";
import {
  ActionItems,
  AgentSessionBrand,
  AgentSessionBrandStatus,
  BrandSearchResult,
  Message,
  PayloadType,
} from "./index";

interface MessageContentProps {
  msg: Message;
  getSessionBrand: (brand: BrandSearchResult) => AgentSessionBrand | undefined;
  isBrandLoading: (brand: BrandSearchResult) => boolean;
  addBrand: (brand: BrandSearchResult) => void;
}

const MessageContent = ({
  msg,
  getSessionBrand,
  isBrandLoading,
  addBrand,
}: MessageContentProps) => {
  const { discoverTab } = useContext(DiscoverViewContext);

  return (
    <Box>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: msg.role === "user" ? "flex-end" : "flex-start",
        }}
      >
        <Paper
          elevation={0}
          sx={{
            px: msg.role === "user" ? 2 : 0,
            py: 0.75,
            my: 1,
            bgcolor: msg.role === "user" ? "primary.main" : "transparent",
            whiteSpace: "pre-wrap",
            borderRadius: "16px",
          }}
        >
          <Markdown
            content={msg.text || ""}
            color={msg.role === "user" ? "white" : "inherit"}
          />
        </Paper>
      </Box>
      <Grid container spacing={1}>
        {msg.payload_type === PayloadType.action_items &&
          (msg.payload as ActionItems)?.action_items?.map(
            (actionItemPreview) => {
              return (
                <Grid key={actionItemPreview.id} item xs={12}>
                  <ActionItem preview={actionItemPreview} />
                </Grid>
              );
            },
          )}

        {msg.payload_type === PayloadType.brand_search_results &&
          (msg.payload as BrandSearchResult[])?.map((brand, i) => {
            const sessionBrand = getSessionBrand(brand);
            return (
              <Grid
                key={i}
                item
                xs={12}
                sm={6}
                md={discoverTab === null ? 4 : 12}
                lg={discoverTab === null ? 4 : 6}
              >
                <BrandCard
                  brand={brand}
                  isLoading={isBrandLoading(brand)}
                  isAdded={
                    sessionBrand?.status === AgentSessionBrandStatus.in_cart
                  }
                  isScheduled={
                    sessionBrand?.status === AgentSessionBrandStatus.scheduled
                  }
                  addBrand={addBrand}
                />
              </Grid>
            );
          })}
      </Grid>
      {msg.payload_type === PayloadType.brand_search_results &&
        msg.payload &&
        (msg.payload as BrandSearchResult[]).length > 0 && (
          <Typography sx={{ my: 2 }}>
            Feel free to click the "Pitch +" button to add each of the brands
            you want to schedule an email to above!
          </Typography>
        )}
    </Box>
  );
};

export default MessageContent;
